import { render, staticRenderFns } from "./feedbackAppDetails.vue?vue&type=template&id=049fb900&scoped=true"
import script from "./feedbackAppDetails.vue?vue&type=script&lang=js"
export * from "./feedbackAppDetails.vue?vue&type=script&lang=js"
import style0 from "./feedbackAppDetails.vue?vue&type=style&index=0&id=049fb900&prod&scoped=true&lang=scss"
import style1 from "./feedbackAppDetails.vue?vue&type=style&index=1&id=049fb900&prod&lang=css"
import style2 from "./feedbackAppDetails.vue?vue&type=style&index=2&id=049fb900&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049fb900",
  null
  
)

export default component.exports